import * as Yup from "yup";

export const AddOrUpdateQualityResult = Yup.object().shape({
  name: Yup.string().nullable().required("quality.name-validation"),
  result_type: Yup.string().nullable().required("quality.type-validation"),
});
